module.exports = __webpack_public_path__ + "static/media/Icon_active.f2e19ec4.svg";